import {Box, IconButton, Typography} from '@mui/material';
import {FC, useState} from 'react';

import {DashboardEntity} from '../../interfaces/Dashboard';

const ENABLED = false;

interface Props {
  savedEntities: DashboardEntity[];
  currentEntities: DashboardEntity[];
}

const DashboardDebugPanel: FC<Props> = ({savedEntities, currentEntities}) => {
  const [open, setOpen] = useState(false);

  if (!ENABLED) {
    return null;
  }

  const savedIds = savedEntities.map((e) => e.id);
  const currentIds = currentEntities.map((e) => e.id);
  const addedIds = currentIds.filter((id) => !savedIds.includes(id));
  const removedIds = savedIds.filter((id) => !currentIds.includes(id));

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 64,
        right: 8,
        zIndex: 9999,
        maxWidth: 420,
        maxHeight: '80vh',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.85)',
        color: '#0f0',
        fontFamily: 'monospace',
        fontSize: 11,
        borderRadius: 1,
        p: open ? 1.5 : 0.5,
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          sx={{fontSize: 11, fontFamily: 'monospace', color: '#0f0', mr: 1}}
        >
          Dashboard Debug
        </Typography>
        <IconButton
          size="small"
          onClick={() => setOpen(!open)}
          sx={{color: '#0f0', fontSize: 11, p: 0.5}}
        >
          {open ? '▲' : '▼'}
        </IconButton>
      </Box>

      {open && (
        <Box mt={1}>
          <Box mb={1}>
            <Box sx={{color: '#ff0'}}>
              Saved: {savedEntities.length} | Current: {currentEntities.length}
            </Box>
            {addedIds.length > 0 && (
              <Box sx={{color: '#0ff'}}>Added (unsaved): {addedIds.length}</Box>
            )}
            {removedIds.length > 0 && (
              <Box sx={{color: '#f66'}}>
                Removed (unsaved): {removedIds.length}
              </Box>
            )}
          </Box>

          <Box mb={1}>
            <Box sx={{color: '#ff0', mb: 0.5}}>Saved Entities:</Box>
            {savedEntities.map((e) => (
              <Box key={e.id} sx={{pl: 1, mb: 0.5}}>
                <Box>
                  {e.panel?.code} [{e.id.slice(0, 8)}]
                </Box>
                <Box sx={{color: '#888'}}>
                  grid: {e.grid.x},{e.grid.y} {e.grid.w}x{e.grid.h}
                </Box>
              </Box>
            ))}
          </Box>

          <Box>
            <Box sx={{color: '#ff0', mb: 0.5}}>Current Entities:</Box>
            {currentEntities.map((e) => {
              const saved = savedEntities.find((s) => s.id === e.id);
              const isNew = !saved;
              const gridChanged =
                saved &&
                (saved.grid.x !== e.grid.x ||
                  saved.grid.y !== e.grid.y ||
                  saved.grid.w !== e.grid.w ||
                  saved.grid.h !== e.grid.h);
              return (
                <Box key={e.id} sx={{pl: 1, mb: 0.5}}>
                  <Box>
                    {e.panel?.code} [{e.id.slice(0, 8)}]
                    {isNew && (
                      <Box component="span" sx={{color: '#0ff'}}>
                        {' '}
                        NEW
                      </Box>
                    )}
                    {gridChanged && (
                      <Box component="span" sx={{color: '#f90'}}>
                        {' '}
                        MOVED
                      </Box>
                    )}
                  </Box>
                  <Box sx={{color: '#888'}}>
                    grid: {e.grid.x},{e.grid.y} {e.grid.w}x{e.grid.h}
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default DashboardDebugPanel;
